module.exports = __webpack_public_path__ + "static/media/Janitor.280999b5.jpg";